import React from "react";

function getStars(value) {
    const stars = [];
    const [whole, part] = parseFloat(value).toString().split(".");
    for (let i = 0; i < whole; i++) stars.push(100);
    if (part) stars.push(50);
    for (let i = whole; i < (part ? 4 : 5); i++) stars.push(0);
    return stars;
}

function mapRating(rating) {
    return (rating / 5) * 100;
}

const ProductRatingStars = ({ rating, src = "/images/icon/{value}.svg", size, elem }) => {
    const _rating = elem ? elem.dataset.rating : rating;

    return (
        <div
            className="d-flex align-items-center position-relative"
            style={{ width: "fit-content" }}
        >
            <div className="d-flex align-items-center">
                {Array.from({ length: 5 }).map((_, i) => (
                    <img
                        key={i}
                        src={src.replace("{value}", "0")}
                        alt="star"
                        style={size ? { height: size, width: size } : {}}
                    />
                ))}
            </div>
            <div
                className="position-absolute h-100 w-100 d-flex align-items-center"
                style={{
                    top: 0,
                    left: 0,
                    clipPath: `polygon(0 0, ${mapRating(_rating)}% 0, ${mapRating(
                        _rating
                    )}% 100%, 0 100%)`,
                }}
            >
                {Array.from({ length: 5 }).map((_, i) => (
                    <img
                        key={i}
                        src={src.replace("{value}", "100")}
                        alt="star"
                        style={size ? { height: size, width: size } : {}}
                    />
                ))}
            </div>
        </div>
    );
};

export default ProductRatingStars;
